import { AfterViewInit, Component, Input } from '@angular/core';
import * as L from 'leaflet';
import { LatLng, LatLngExpression, Marker } from 'leaflet';
import { Pin } from './model/pin';

import { MarkerDataExtended } from './model/marker-data-extended';
import { MapService } from './map.service';
import 'leaflet/dist/leaflet.css';
import { IconPinService } from '@app/components/shared/map/icon-pin.service';

@Component({
  selector: 'faxe-map',
  standalone: true,
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
  imports: [],
})
export class MapComponent implements AfterViewInit {
  @Input() mapId: string = 'map';

  @Input() set pins(pins: Pin[]) {
    this.mPins = pins;
  }

  placePin: boolean;
  initialSkovde: LatLngExpression = [58.3891, 13.8448];
  mPins: Pin[];
  markerDatasExtended: MarkerDataExtended[] = null;
  private leafletmap!: L.Map;

  constructor(private readonly mapService: MapService) {
    this.mapService.onFocusCenter.subscribe((focusCenter) =>
      this.offseetCenter(focusCenter)
    );

    this.mapService.onDeleteMarker.subscribe((id) => {
      const lMarkerData: MarkerDataExtended = this.markerDatasExtended?.find(
        (m) => m.id() === id
      );
      lMarkerData?.setIcon(IconPinService.newIcon('red'));
    });
  }

  private updateMapPins(pins: Pin[] | null): void {
    this.clearMarkers();

    this.markerDatasExtended = pins?.map((pin) =>
      this.toMarkerDataExtended(pin)
    );
    this.markerDatasExtended?.forEach((marker) => {
      this.addMarker(marker);
    });
  }

  private toMarkerDataExtended(pin: Pin): MarkerDataExtended {
    const markerData = new MarkerDataExtended(
      [pin.latitude, pin.longitude],
      pin.attributes,
      { icon: IconPinService.newIcon('green') }
    );
    markerData.bindPopup(
      '<b>' + pin.name + '</b><p>' + pin.description + '</p>'
    );
    return markerData;
  }

  private clearMarkers(): void {
    this.leafletmap?.eachLayer((layer) => {
      if (layer instanceof L.Marker) {
        this.leafletmap.removeLayer(layer);
      }
    });
  }

  onMarkerClick(e: L.LeafletMouseEvent): void {
    this.resetIcons();
    const markerData = e.target as MarkerDataExtended;
    markerData.setIcon(IconPinService.newIcon('green'));
  }

  resetIcons() {
    this.markerDatasExtended.forEach((marker) => {
      marker.setIcon(IconPinService.newIcon('blue'));
    });
  }

  private initMap(): void {
    this.leafletmap = L.map(this.mapId, {
      center: this.initialSkovde,
      zoom: 12,
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      minZoom: 3,
      attribution:
        '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(this.leafletmap);

    this.leafletmap.on('click', (e) => this.onMapClick(e));
  }

  public ngAfterViewInit(): void {
    this.initMap();
    this.updateMapPins(this.mPins);
  }

  onMapClick(e: L.LeafletMouseEvent): void {
    if (this.placePin || true) {
      let marker: Marker = new Marker([e.latlng.lat, e.latlng.lng], {
        icon: IconPinService.newIcon('green'),
      });
      marker.addTo(this.leafletmap);
      this.offseetCenter(e.latlng);
    } else {
      this.resetIcons();
    }
  }

  offseetCenter(latLng: LatLng) {
    if (latLng) {
      let offsetCenter = <LatLng>{
        lat: latLng.lat - 0.0009,
        lng: latLng.lng,
      };
      this.leafletmap.setView(offsetCenter, 18);
    }
  }

  addMarker(marker: Marker): void {
    marker.on('click', (e) => this.onMarkerClick(e));
    marker.addTo(this.leafletmap);
  }
}
